var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "消息模版新增",
            visible: _vm.visible,
            "close-on-click-modal": false,
            width: "40%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { ref: "newsForm", attrs: { model: _vm.newsForm, size: "mini" } },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "企业名称（支持模糊搜索）",
                    prop: "enterpriseId",
                    rules: [
                      {
                        required: true,
                        message: "请选择企业名称",
                        trigger: "change",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { filterable: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.companyIdChange($event)
                        },
                      },
                      model: {
                        value: _vm.newsForm.enterpriseId,
                        callback: function ($$v) {
                          _vm.$set(_vm.newsForm, "enterpriseId", $$v)
                        },
                        expression: "newsForm.enterpriseId",
                      },
                    },
                    _vm._l(_vm.comanyList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { value: item.id, label: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "模版名称",
                    prop: "name",
                    rules: [
                      {
                        required: true,
                        message: "请输入模版名称",
                        trigger: "bulr",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.newsForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.newsForm, "name", $$v)
                      },
                      expression: "newsForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "消息类型",
                    prop: "type",
                    rules: [
                      {
                        required: true,
                        message: "请输入消息类型",
                        trigger: "bulr",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.newsForm.type,
                      callback: function ($$v) {
                        _vm.$set(_vm.newsForm, "type", $$v)
                      },
                      expression: "newsForm.type",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "消息模版ID",
                    prop: "templateId",
                    rules: [
                      {
                        required: true,
                        message: "请输入消息模版ID",
                        trigger: "bulr",
                      },
                    ],
                  },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.newsForm.templateId,
                      callback: function ($$v) {
                        _vm.$set(_vm.newsForm, "templateId", $$v)
                      },
                      expression: "newsForm.templateId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "是否启用",
                    prop: "state",
                    rules: [
                      {
                        required: true,
                        message: "请选择启用状态",
                        trigger: "bulr",
                      },
                    ],
                  },
                },
                [
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 1 },
                      model: {
                        value: _vm.newsForm.state,
                        callback: function ($$v) {
                          _vm.$set(_vm.newsForm, "state", $$v)
                        },
                        expression: "newsForm.state",
                      },
                    },
                    [_vm._v("启用")]
                  ),
                  _c(
                    "el-radio",
                    {
                      attrs: { label: 2 },
                      model: {
                        value: _vm.newsForm.state,
                        callback: function ($$v) {
                          _vm.$set(_vm.newsForm, "state", $$v)
                        },
                        expression: "newsForm.state",
                      },
                    },
                    [_vm._v("禁用")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "mini" },
                  on: {
                    click: function ($event) {
                      _vm.visible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.newsSubmit("newsForm")
                    },
                  },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-form",
        { attrs: { model: _vm.params, size: "mini", inline: true } },
        [
          _c(
            "el-form-item",
            { attrs: { label: "企业名称" } },
            [
              _c("el-input", {
                model: {
                  value: _vm.params.enterpriseName,
                  callback: function ($$v) {
                    _vm.$set(_vm.params, "enterpriseName", $$v)
                  },
                  expression: "params.enterpriseName",
                },
              }),
            ],
            1
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "mini" },
              on: {
                click: function ($event) {
                  return _vm.loadNewsList(true)
                },
              },
            },
            [_vm._v("查询")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "danger", size: "mini", icon: "el-icon-plus" },
              on: {
                click: function ($event) {
                  return _vm.add(true)
                },
              },
            },
            [_vm._v("添加消息模版")]
          ),
        ],
        1
      ),
      _c(
        "el-table",
        { attrs: { data: _vm.tableData, stripe: "" } },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              type: "index",
              width: "55",
              label: "序号",
            },
          }),
          _c("el-table-column", { attrs: { prop: "name", label: "模板名称" } }),
          _c("el-table-column", {
            attrs: { prop: "enterpriseName", label: "企业名称" },
          }),
          _c("el-table-column", { attrs: { prop: "type", label: "类型" } }),
          _c("el-table-column", {
            attrs: { prop: "templateId", label: "消息ID" },
          }),
          _c("el-table-column", {
            attrs: { prop: "state", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    scope.row.state === 1
                      ? [_c("el-tag", [_vm._v("启用")])]
                      : _vm._e(),
                    scope.row.state === 2
                      ? [
                          _c("el-tag", { attrs: { type: "danger" } }, [
                            _vm._v("禁用"),
                          ]),
                        ]
                      : _vm._e(),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.apply(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.state === 1 ? "禁用" : "启用"))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.add(scope.row)
                          },
                        },
                      },
                      [_vm._v("修改")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "mini" },
                        on: {
                          click: function ($event) {
                            return _vm.del(scope.row)
                          },
                        },
                      },
                      [_vm._v("删除")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c(
        "el-row",
        [
          _c("el-pagination", {
            staticClass: "page-footer",
            attrs: {
              background: "",
              layout: "total,prev,pager,next,sizes,jumper",
              total: _vm.total,
              "page-sizes": [10, 20, 30, 40, 50],
            },
            on: {
              "current-change": _vm.handlePageChange,
              "size-change": _vm.handleSizeChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }